import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import RenderField from "../../../components/RenderField";
import { fetchUserById } from "../../../api/userService";
import { usePermissions } from "../../../hooks/usePermissions";
import { formatDateTime } from "../../../utils/dateTimeUtil";
export var TimestampsSection = function (_a) {
    var _b, _c;
    var publisher = _a.publisher;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var canViewPublisherEditor = usePermissions().canViewPublisherEditor;
    var createTime = publisher.createTime, activationTime = publisher.activationTime, dataConfirmationTime = publisher.dataConfirmationTime, closeTime = publisher.closeTime, metadata = publisher.metadata, status = publisher.status;
    var updatedByUserId = metadata === null || metadata === void 0 ? void 0 : metadata.updatedByUserId;
    var updatedByUser = useQuery(["users", updatedByUserId], function () { return fetchUserById(ky, updatedByUserId); }, { enabled: canViewPublisherEditor && !!updatedByUserId, retry: false }).data;
    var updatedByName = updatedByUser
        ? "".concat((_b = updatedByUser.firstName) !== null && _b !== void 0 ? _b : "", " ").concat((_c = updatedByUser.lastName) !== null && _c !== void 0 ? _c : "").trim()
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.createTime",
                    }), value: formatDateTime(createTime) })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.activationTime",
                    }), value: formatDateTime(activationTime) }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.dataConfirmationTime",
                    }), value: formatDateTime(dataConfirmationTime) })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.closeTime",
                    }), value: formatDateTime(closeTime) }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.updatedDate",
                    }), value: formatDateTime(metadata === null || metadata === void 0 ? void 0 : metadata.updatedDate) })),
            canViewPublisherEditor && (React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.updatedBy",
                    }), value: updatedByName })))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(RenderField, { label: formatMessage({
                        id: "ui-br-publishers.publishers.timestamps.field.label.status",
                    }), value: formatMessage({
                        id: "ui-br-publishers.status.".concat(status.toLowerCase()),
                    }) })))));
};
